/*--------------------------------------
 ANIMATIONS BLOG ARCHIVE
 --------------------------------------*/
BlogArchive = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        if ($(window).width() <= 992) {
            //ITEMS
            $('.blog-archive__item').each(function () {
                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .3,
                })
                    .setClassToggle(this, "active")
                    //.addIndicators()
                    .addTo(controller);
            });
        }
        else {
            //ITEMS
            $('.blog-archive__item').each(function () {
                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .45,
                })
                    .setClassToggle(this, "active")
                    //.addIndicators()
                    .addTo(controller);
            });
        }

    }
};

$(document).ready(function () {
    $(".about-values").insertAfter( ".blog-archive__item:nth-child(4)" );
    if ($(window).width() > 640) {
        BlogArchive.init();
    }
});
$(document).on('shopify:section:load', function (event) {
    if ($(window).width() > 640) {
        BlogArchive.init();
    }else{
        $(".about-values").insertAfter( ".blog-archive__item:nth-child(4)" );

    }
});